export let ActiveServicesReportEntryApiOccurrence = /*#__PURE__*/function (ActiveServicesReportEntryApiOccurrence) {
  ActiveServicesReportEntryApiOccurrence["OneTime"] = "One-time";
  ActiveServicesReportEntryApiOccurrence["Weekly"] = "Weekly";
  ActiveServicesReportEntryApiOccurrence["BiWeekly"] = "Bi-weekly";
  ActiveServicesReportEntryApiOccurrence["Monthly"] = "Monthly";
  ActiveServicesReportEntryApiOccurrence["Quarterly"] = "Quarterly";
  ActiveServicesReportEntryApiOccurrence["Yearly"] = "Yearly";
  return ActiveServicesReportEntryApiOccurrence;
}({});
export let ActiveServicesReportEntryApiTrigger = /*#__PURE__*/function (ActiveServicesReportEntryApiTrigger) {
  ActiveServicesReportEntryApiTrigger["Manual"] = "Manual";
  ActiveServicesReportEntryApiTrigger["Automatic"] = "Automatic";
  return ActiveServicesReportEntryApiTrigger;
}({});
export let ActiveServicesReportEntryApiPricing = /*#__PURE__*/function (ActiveServicesReportEntryApiPricing) {
  ActiveServicesReportEntryApiPricing["Fixed"] = "Fixed";
  ActiveServicesReportEntryApiPricing["Range"] = "Range";
  ActiveServicesReportEntryApiPricing["PerHour"] = "Per hour";
  ActiveServicesReportEntryApiPricing["PerUnit"] = "Per unit";
  return ActiveServicesReportEntryApiPricing;
}({});
export let ActiveServicesReportEntryApiAutomaticServiceState = /*#__PURE__*/function (ActiveServicesReportEntryApiAutomaticServiceState) {
  ActiveServicesReportEntryApiAutomaticServiceState["Active"] = "Active";
  ActiveServicesReportEntryApiAutomaticServiceState["Paused"] = "Paused";
  return ActiveServicesReportEntryApiAutomaticServiceState;
}({});
export let ActiveServicesReportEntryApiStatus = /*#__PURE__*/function (ActiveServicesReportEntryApiStatus) {
  ActiveServicesReportEntryApiStatus["Active"] = "Active";
  ActiveServicesReportEntryApiStatus["Amended"] = "Amended";
  ActiveServicesReportEntryApiStatus["Inactive"] = "Inactive";
  return ActiveServicesReportEntryApiStatus;
}({});